import { all, call, put, takeLatest } from "redux-saga/effects";
import { getIncomeApi } from "core/http/service/salary";
import {
  getSalaryDetailFailed,
  getSalaryDetailStart,
  getSalaryDetailSuccess,
} from "../redux/getSalaryDetail";

function* getSalaryDetail(_action: ReturnType<typeof getSalaryDetailStart>) {
  try {
    const data = yield call(getIncomeApi);
    yield put({
      type: getSalaryDetailSuccess.type,
      payload: { data },
    });
  } catch (_error) {
    yield put({ type: getSalaryDetailFailed.type });
  }
}

function* watchGetSalaryDetail() {
  yield takeLatest(getSalaryDetailStart.type, getSalaryDetail);
}

export default function* getSalaryDetailSaga() {
  yield all([watchGetSalaryDetail()]);
}
